import Typography from '@mui/material/Typography';

import styles from './scenario-title-row.module.scss';

type ScenarioTitleRowProps = {
  scenarioTitle: string;
  description: string;
};

const ScenarioTitleRow = ({ scenarioTitle, description }: ScenarioTitleRowProps) => (
  <div className={styles.scenarioTitleContainer}>
    <Typography variant="subtitle1">{`${scenarioTitle} ${description}`}</Typography>
  </div>
);

export default ScenarioTitleRow;
